export function formatTimestamp(timestamp: Date) {
  const timeWithoutMiliseconds = timestamp.toTimeString().slice(0, 8)
  const miliseconds = timestamp.getMilliseconds().toString().padStart(3, '0')
  return `${timeWithoutMiliseconds}.${miliseconds}`
}
